import { render, staticRenderFns } from "./MinhaAplicacao.vue?vue&type=template&id=0c3f7174&scoped=true"
import script from "./MinhaAplicacao.vue?vue&type=script&lang=js"
export * from "./MinhaAplicacao.vue?vue&type=script&lang=js"
import style0 from "./MinhaAplicacao.vue?vue&type=style&index=0&id=0c3f7174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3f7174",
  null
  
)

export default component.exports